import type {
  ItemType,
  PublicCatalogItem,
  PublicCatalogItemDetail,
} from "@bash/shared";
import { apiUrl } from "./base";

const TYPE_TO_URL: Record<ItemType, string> = {
  skill: "skills",
  agent: "agents",
  hook: "hooks",
  mcp: "mcps",
};

export interface PublicCatalogPage {
  items: PublicCatalogItem[];
  total: number;
  has_more: boolean;
}

function urlSegment(type: ItemType | string): string {
  return (TYPE_TO_URL as Record<string, string>)[type] ?? String(type);
}

export async function listPublicCatalog(
  type: ItemType | string,
  opts: { limit?: number; offset?: number } = {}
): Promise<PublicCatalogPage> {
  const params = new URLSearchParams();
  if (opts.limit != null) params.set("limit", String(opts.limit));
  if (opts.offset != null) params.set("offset", String(opts.offset));
  const qs = params.toString();
  const res = await fetch(
    apiUrl(`/api/catalog/${urlSegment(type)}${qs ? `?${qs}` : ""}`)
  );
  if (!res.ok) throw new Error(`catalog list failed: ${res.status}`);
  return (await res.json()) as PublicCatalogPage;
}

export async function getPublicCatalogItem(
  type: ItemType | string,
  slug: string
): Promise<PublicCatalogItemDetail | null> {
  const res = await fetch(
    apiUrl(`/api/catalog/${urlSegment(type)}/${encodeURIComponent(slug)}`)
  );
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`catalog detail failed: ${res.status}`);
  return (await res.json()) as PublicCatalogItemDetail;
}
